export default "__VITE_ASSET__Cb8_$uWM__"